export default interface Token {
    id?: string
    userId?: string
    authorizer?: Authorizer
}

export enum Authorizer {
    RGTDB = "RGTDB"
}